import { useEffect, useState } from "react";
import { useRouterState } from "@tanstack/react-router";
import { FullPageLoader } from "@/components/ui/loader";

/**
 * Shows the loader for ~2.5s on initial mount and during route transitions.
 */
export function RouteChangeLoader() {
  const isLoading = useRouterState({ select: (s) => s.isLoading || s.status === "pending" });
  const [show, setShow] = useState(true);

  // Initial mount: keep visible for 2.5s
  useEffect(() => {
    const t = setTimeout(() => setShow(false), 2500);
    return () => clearTimeout(t);
  }, []);

  // On route change: show, then hide after 2.5s
  useEffect(() => {
    if (isLoading) {
      setShow(true);
      return;
    }
    const t = setTimeout(() => setShow(false), 2500);
    return () => clearTimeout(t);
  }, [isLoading]);

  if (!show) return null;
  return <FullPageLoader />;
}
